import { BASE_SELECT_DEFAULT_MODE, BASE_SELECT_DEFAULT_ROLE, BASE_SELECT_DEFAULT_SIZE } from '../../common/BaseSelect/BaseSelect.constants';
// Constants.
// -----------------------------------------------------------------------------
/** Default disabled value. */
export const SELECT_DEFAULT_DISABLED = false;
/** Default mode. */
export const SELECT_DEFAULT_MODE = BASE_SELECT_DEFAULT_MODE;
/** Default placeholder. */
export const SELECT_DEFAULT_PLACEHOLDER = '';
/** Default size. */
export const SELECT_DEFAULT_SIZE = BASE_SELECT_DEFAULT_SIZE;
/** Default role. */
export const TEXT_FIELD_DEFAULT_ROLE = BASE_SELECT_DEFAULT_ROLE;
//# sourceMappingURL=Select.constants.js.map